export const MCP_TRANSPORT_LABELS: Record<number, string> = {
  0: '未指定',
  1: 'SSE',
  2: 'Streamable HTTP',
  3: 'STDIO',
};
